export default {
    // C
    conversations: 'Conversations',
}
